module.exports = __webpack_public_path__ + "static/media/project-completed.71fb8157.mp3";